import { render } from "./BindAlipay.vue?vue&type=template&id=68f36455&scoped=true"
import script from "./BindAlipay.vue?vue&type=script&lang=js"
export * from "./BindAlipay.vue?vue&type=script&lang=js"

import "./BindAlipay.vue?vue&type=style&index=0&id=68f36455&scoped=true&lang=stylus"

import exportComponent from "/Users/test/Desktop/source/work/H5-client/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-68f36455"]])

export default __exports__